var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1f42f806378fc24de3be1fa2c738df2c.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3702aeab5386a0be372f6363389d4437.js').default;
var scope_3 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7abc8de1c2e52bc6c23b27d2b9ef39ac.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    